export default __webpack_public_path__ + "static/media/share_link_icon.55accb0e.png";